export const board = [
  { num: 0, color: "" },
  { num: 32, color: "" },
  { num: 15, color: "" },
  { num: 19, color: "" },
  { num: 4, color: "" },
  { num: 21, color: "" },
  { num: 2, color: "" },
  { num: 25, color: "" },
  { num: 17, color: "" },
  { num: 34, color: "" },
  { num: 6, color: "" },
  { num: 27, color: "" },
  { num: 13, color: "" },
  { num: 36, color: "" },
  { num: 11, color: "" },
  { num: 30, color: "" },
  { num: 8, color: "" },
  { num: 23, color: "" },
  { num: 10, color: "" },
  { num: 5, color: "" },
  { num: 24, color: "" },
  { num: 16, color: "" },
  { num: 33, color: "" },
  { num: 1, color: "" },
  { num: 20, color: "" },
  { num: 14, color: "" },
  { num: 31, color: "" },
  { num: 9, color: "" },
  { num: 22, color: "" },
  { num: 18, color: "" },
  { num: 29, color: "" },
  { num: 7, color: "" },
  { num: 28, color: "" },
  { num: 12, color: "" },
  { num: 35, color: "" },
  { num: 3, color: "" },
  { num: 26, color: "" },
];
